var _g, _rect, _rect2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1840_2190)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#D7E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 25C29.6043 25 33.3335 21.2709 33.3335 16.6667C33.3335 12.0625 29.6043 8.33337 25.0002 8.33337C20.396 8.33337 16.6668 12.0625 16.6668 16.6667C16.6668 21.2709 20.396 25 25.0002 25ZM25.0002 29.1667C19.4377 29.1667 8.3335 31.9584 8.3335 37.5V47.9167C8.3335 49.0625 9.271 50 10.4168 50H39.5835C40.7293 50 41.6668 49.0625 41.6668 47.9167V37.5C41.6668 31.9584 30.5627 29.1667 25.0002 29.1667Z",
    fill: "#132543"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33,
    width: 16.6087,
    height: 16.6087,
    rx: 8.30433,
    fill: "#0060FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1840_2190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 35,
    width: 13,
    height: 13
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4429,
    y: 35.9309,
    width: 11.7238,
    height: 11.7238,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1840_2190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8852 45.2123H39.5691L43.7823 40.999L43.0984 40.3151L38.8852 44.5284V45.2123ZM45.8706 40.2907L43.7945 38.2391L44.4784 37.5552C44.6656 37.3679 44.8956 37.2743 45.1684 37.2743C45.4411 37.2743 45.6711 37.3679 45.8584 37.5552L46.5423 38.2391C46.7295 38.4263 46.8272 38.6522 46.8354 38.9168C46.8435 39.1814 46.7539 39.4074 46.5667 39.5946L45.8706 40.2907ZM45.1623 41.0112L39.9843 46.1892H37.9082V44.1132L43.0862 38.9352L45.1623 41.0112Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1840_2190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f1593536ae8a24890c682dc7caf496a3.svg";
export { ForwardRef as ReactComponent };